(function() {
    'use strict';

    angular
        .module('atheer.anchor')
        .controller('AnchorInsightOverviewController', AnchorInsightOverviewController)

    /* @ngInject */
    function AnchorInsightOverviewController($scope, $q, $filter, id, Report) {
        var vm = this;

        vm.loadingData = false;

        vm.anchorScansByDay = {
            chart: {
                type: 'column',
            },
            title: {
                text: $filter('translate')('atheer.anchor.scanPerDay')
            },
            credits: {
                enabled: false
            },
            exporting: {
                enabled: false
            },
            yAxis: {
                title: {
                    text: $filter('translate')('atheer.anchor.noOfScans')
                },
                allowDecimals: false
            },
            xAxis: {
                categories: [],
                labels: {
                    enabled: true
                }
            },
            plotOptions: {
                series: {
                    stacking: 'normal'
                }
            },
            series: [{
                name: $filter('translate')('atheer.anchor.dates'),
                color: vm.primaryColor,
                data: []
            }],
            tooltip: {
                formatter: function() {
                    return '<b>' + this.series.name + '</b> : ' + this.y + ' ' + this.x;
                }
            }
        };

        function performDataProcess() {
            angular.forEach(vm.dashboardModel.anchor_scan_by_day, function(anchorScansByDay) {
                vm.anchorScansByDay.xAxis.categories.push(anchorScansByDay.name);
                vm.anchorScansByDay.series[0].data.push(anchorScansByDay.count);
            });

            vm.loadingData = false;
        }
        
        vm.loadData = function() {
           vm.loadingData = true;

            var resource = Report.getAnchorSummary({
                id : id
            }).$promise;

            $q.all([
                    resource
                ])
                .then(function(results) {
                    vm.dashboardModel = results[0];
                    performDataProcess();
                });
        }

        vm.loadData();
    }
})();
